import { createToastInterface } from "vue-toastification";
import type { PluginOptions } from "vue-toastification";
import Interface from "vue-toastification/dist/types/ts/interface";
import { defaultPluginOptions } from "./default-options";

export class EdroneToastSingleton {
  static instance: Interface.ToastInterface | null = null;

  static getInstance(pluginOptions?: PluginOptions) {
    if (this.instance === null) {
      this.instance = createToastInterface({
        ...defaultPluginOptions,
        ...pluginOptions,
      });
      return this.instance;
    } else {
      return this.instance;
    }
  }
}
